import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "component-variable__flex__header" };
const _hoisted_2 = { class: "component-variable__flex__header__label" };
const _hoisted_3 = { class: "component-variable__flex__header__label__prefix" };
const _hoisted_4 = { class: "component-variable__flex__header__label__display-name" };
const _hoisted_5 = {
    key: 0,
    class: "component-variable__flex__header__label__display-name__advanced"
};
const _hoisted_6 = { class: "component-variable__flex__header__label__postfix" };
const _hoisted_7 = {
    key: 0,
    class: "component-variable__flex__header__description"
};
const _hoisted_8 = ["innerHTML"];
import DOMPurify from "dompurify";
import { computed } from "vue";
import Strings from "src/shared/Strings";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableHeader',
    props: {
        displayName: {},
        description: {},
        isAdvanced: { type: Boolean },
        importance: {}
    },
    setup(__props) {
        const props = __props;
        const sanitizedDescription = computed(() => {
            return DOMPurify.sanitize(props.description, {
                ALLOWED_TAGS: ["a"],
                ALLOWED_ATTR: ["href", "target", "rel"],
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "prefix")
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.displayName) + " ", 1 /* TEXT */),
                        (_ctx.isAdvanced)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "- " + _toDisplayString(_unref(Strings).capitalize(_ctx.importance)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "postfix")
                    ])
                ]),
                (_ctx.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("small", { innerHTML: sanitizedDescription.value }, null, 8 /* PROPS */, _hoisted_8)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
